<template>
    <div class="success-page">
        <div class="content">
            <img src="@/assets/success.png" alt="发布成功" class="success-img">
            <p class="success-text">发布成功</p>
            <template v-if = "type == 'fill'">
                <button @click="goDone" class="done-btn">完成</button>
            </template>
            <template v-if = "type == 'fast'">
                <div class="info-tip">
                    <p style="text-align: left;">机器人已根据您填写的职位信息自动生成了部分补充信息</p>
                    <button @click="toggleJobView" class="check-btn">去查看</button>
                </div>
                <div class="button-group">
                    <div @click="goDone" class="done-btn">完成</div>
                    <div style="width: 5px;"></div>
                    <div @click="goFill" class="info-btn">填写补充信息</div>
                </div>
            
            </template>
        </div>

        <div class="half-page" v-if="modal === true" @click="toggleJobView">
            <div class="content" @click.stop>
            <a-row type="flex" justify="space-between" align="middle">
                <a-col class="close" @click="toggleJobView">
                <icon-font type="guanbi" :style="{ fontSize: '19px' }" />
                </a-col>
                <a-col class="new_win" @click="toDetail">
                <a-icon type="fullscreen" />在新窗口打开
                </a-col>
            </a-row>
            <Detail :id="job_id" :tab="tab" scrollToDiv = "candidate"></Detail>
            </div>
        </div>
    </div>
</template>
<script>
import Detail from "@/app/admin/post/detail";
    export default {
        data() {
            return {
                type: 'fill',
                job_id: '',
                modal: false,
                tab: 1,
            };
        },
        components : { Detail },
        methods: {
            goDone() { // 完成
                this.$router.push({
                    path: "/hunter-post",
                });
            },
            goFill(){ // 去完善信息
                this.$router.push({
                path:"/post-new",
                query: {
                    viewType: 1,
                    postId:this.job_id
                }
             });
            },
            toggleJobView() {
                this.modal = !this.modal;
            },
            toDetail() {
                this.toggleJobView();

                let post_id = this.post_id;
                let resolveDRoute = this.$router.resolve({
                    path: `post-detail/${post_id}`
                });
                window.open(resolveDRoute.href, "_blank");
            },
        },
        mounted() {
            const type = this.$route.query.type;
            this.type = type;

            

            const job_id = this.$route.query.job_id;
            if (!job_id || job_id.length <= 0){
                this.job_id = '1';
            }else{
                this.job_id = job_id;
            }
           


        }
    };
</script>
<style scoped lang="scss">
.success-page {
    display: flex;
    justify-content: center;
    // align-items: center;
}
.content {
    text-align: center;
    // margin-top: 100px;
}
.success-img {
    width: 100px;
    height: 100px;
}
.success-text {
    font-size: 18px;
    margin-top: 20px;
}
.done-btn {
    /* margin-top: 10px; */
    margin-left: 10px;
    width: 120px;
    height: 40px; 
    border: 1px solid #17AFFA;
    background-color: white;
    color: #17AFFA;
    cursor: pointer;
    font-size: 14px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    display: flex;
    /* height: 32px; */
}

.info-btn {
    /* margin-top: 10px; */
    width: 120px;
    height: 40px; 
    background-color: #17AFFA;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    display: flex;
}
.info-btn:hover {
    background-color: #17AFFA;
}
.done-btn:hover {
    background-color: white;
}

.info-btn {
    padding: 5px 10px;
    margin: 0 10px;
    background-color: #17AFFA;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    border-radius: 5px;
}
.info-btn:hover {
background-color: #0056b3;
}
.info-tip {
    padding: 10px;
    margin: 10px;
    width: 250px;
    display: flex;
    background-color: #dfdfdf;
    /* justify-content: right; */
    flex-direction: column;
    border-radius: 3px;

}
.check-btn {
    padding: 0px 0px;
    background-color: transparent;
    border: none;
    color: #17AFFA;
    cursor: pointer;
    font-size: 14px;
    border-radius: 5px;
    align-self: flex-end; /* 将元素在交叉轴上靠右对齐 */
    width: auto; /* 宽度自适应内容 */
    white-space: nowrap; /* 防止换行 */
    text-decoration: underline; /* 添加下划线 */
}
.button-group{
    display: flex;
    /* justify-content: space-between; */
}
.half-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    .content {
      margin-left: 50%;
      width: 50%;
      height: 100%;
      overflow: auto;
      background: #fff;
      box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.16);
      padding: 30px 40px;
      .close {
        cursor: pointer;
      }
      .new_win {
        cursor: pointer;
        color: #999;
        display: flex;
        align-items: center;
        .anticon {
          font-size: 16px;
          margin-right: 6px;
        }
      }
    }
  }


</style>